import { useState } from "react";
import classes from "./SetNewPassword.module.css";
import { Button, Heading, Input, Text } from "components/common";
import Header from "../../Header/Header";

const SetNewPassword = ({ setStep }) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const handleResetLink = () => {
    setStep((prev) => prev + 1);
  };
  return (
    <div className={classes.container}>
      <Header
        heading="Forgot Your Password?"
        info="Enter your email address, and we’ll send you instructions to reset your password."
      />
      <div className={classes.inputWrapper}>
        <Input
          name="password"
          value={password}
          setValue={setPassword}
          type="password"
          placeholder="Password"
        />{" "}
        <Input
          name="confirmPassword"
          value={confirmPassword}
          setValue={setConfirmPassword}
          type="password"
          placeholder="Confirm Password"
        />
        <Button wFull onClick={handleResetLink}>
          Reset Password
        </Button>
      </div>
    </div>
  );
};
export default SetNewPassword;
